import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import FancyFeatureGrid from '../components/FancyFeatureGrid.js';
import ContentTile from '../components/ContentTile.js';
import solar from '../images/solarmodul/banner.jpeg';
import { useSEO } from '../components/CustomHook';
import Modal from '../components/Modal.js';
import pdfpic1 from '../images/solarmodul/pdfpic1.png';

const SolarModules = () => {
    useSEO(
        "Solarmodule - Hochwertige Photovoltaik-Module | Schmid Energieberatung",
        "Entdecken Sie unsere hochwertigen Solarmodule für Ihre Photovoltaikanlage. Qualität von renommierten Herstellern für maximale Effizienz und Langlebigkeit.",
        "Solarmodule, Photovoltaik, Solaranlage, Solarmodule kaufen, Photovoltaik Module, Solar Energie",
        "/images/products/solarmodul.webp"
    );

    // State for modals (new approach like StorageSystems.js)
    const [modalData, setModalData] = useState({ isOpen: false, title: '', content: [] });

    // Function to close modal
    const closeModal = () => {
        setModalData({ isOpen: false, title: '', content: [] });
    };

    // Function to open modal for "Maximaler Ertrag bei Teilverschattung"
    const openModalBox1 = () => {
        setModalData({
            isOpen: true,
            title: "Maximaler Ertrag bei Teilverschattung",
            content: [
                "Maximale Effizienz – auch bei Teilverschattung: Das AIKO Neostar 3S+",
                "Das AIKO Neostar 3S+ Full Black Modul überzeugt durch seine hochmoderne N-Type ABC-Technologie, bei der sämtliche Kontakte auf der Zellrückseite liegen. Dadurch wird die komplette Zellvorderseite zur aktiven Energiegewinnung genutzt – für mehr Lichtaufnahme, weniger Verluste und einen Wirkungsgrad von bis zu 24,3 %.",
                "Besonders bei Teilverschattung spielt das Modul seine Stärken aus: Die spezielle Zellstruktur und Verschaltung sorgen dafür, dass verschattete Bereiche nicht die Leistung des gesamten Moduls beeinträchtigen – im Gegensatz zu herkömmlichen Modulen. Ob durch Laub, Schnee oder benachbarte Objekte: Der Energiefluss bleibt stabil und effizient.",
                "Der robuste Glas-Glas-Aufbau schützt die Zellen zusätzlich vor Umwelteinflüssen, sorgt für eine besonders lange Lebensdauer und kommt mit einer 30-jährigen Produkt- und Leistungsgarantie."
            ]
        });
    };

    // Function to open modal for "24,3% Wirkungsgrad"
    const openModalBox2 = () => {
        setModalData({
            isOpen: true,
            title: "24,3% Wirkungsgrad",
            content: [
                "Effizienz auf höchstem Niveau",
                "Der Wirkungsgrad gibt an, wie viel Sonnenenergie eine Solarzelle in elektrischen Strom umwandeln kann – ein zentraler Faktor für die Leistungsfähigkeit Ihrer Photovoltaikanlage.",
                "Mit einem Wirkungsgrad von bis zu 23,8% zählen die AIKO Neostar 3S+ Full Black Module zur Spitzenklasse. Sie ermöglichen es, aus jedem Sonnenstrahl mehr Energie zu gewinnen – und das spiegelt sich direkt in Ihrer Stromrechnung wider. Höhere Erträge pro Quadratmeter sorgen für eine deutlich bessere Wirtschaftlichkeit und verkürzen die Amortisationszeit Ihrer Anlage spürbar.",
                "Vor allem bei begrenztem Platzangebot spielt ein hoher Wirkungsgrad seine Vorteile aus: Auch kleine Dachflächen werden so optimal genutzt. In einer Zeit, in der Energiepreise steigen und Nachhaltigkeit immer mehr an Bedeutung gewinnt, bietet AIKO die perfekte Kombination aus starker Leistung, modernster Technologie und langfristiger Effizienz."
            ]
        });
    };

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={solar}
                title="Solarmodule"
                subtitle="Nutzen Sie die Kraft der Sonne"
                description="Unsere hochwertigen Solarmodule ermöglichen Ihnen die optimale Nutzung von Sonnenenergie und sind die Basis für eine zukunftssichere Stromversorgung."
            />

            {/* Fancy Feature Grid */}
            <FancyFeatureGrid />

            {/* Textabschnitte */}
            <div className="w-full max-w-7xl mx-auto py-20 px-6">

                {/* Secondary Navigation */}
                <div className="flex justify-center mb-16">
                    <div className="bg-secondary-light rounded-full px-4 py-2 flex flex-wrap justify-center gap-2 sm:gap-4">
                        <a href="#mehr-energie" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Energie
                        </a>
                        <a href="#mehr-vertrauen" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Vertrauen
                        </a>
                        <a href="#mehr-lebenszeit" className="px-4 py-2 text-sm sm:text-base font-semibold text-tertiary hover:text-primary transition-colors duration-200">
                            Mehr Lebenszeit
                        </a>
                    </div>
                </div>

                {/* Mehr Energie Section */}
                <div id="mehr-energie" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Energie
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Höchste Energieerträge durch modernste Solartechnologie
                    </h4>
                    <div className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        <p className="mb-6">
                            Die Leistung Ihrer Photovoltaikanlage steht und fällt mit der Qualität der Module. Unsere innovativen Module holen das Maximum aus jedem Sonnenstrahl heraus – selbst bei diffusem Licht oder schlechtem Wetter.
                        </p>
                        <p>
                            Das bedeutet für Sie: mehr Strom vom Dach, mehr Wirtschaftlichkeit, mehr Unabhängigkeit.
                        </p>
                    </div>

                    {/* Two tiles side by side */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-12">
                        <ContentTile
                            title="475 Wp Hohe Leistungsfähigkeit mit bis zu 5 W positiver Leistungstoleranz"
                            className="text-center bg-secondary-light text-tertiary h-full p-8"
                            centerVertically={true}
                        />
                        <ContentTile
                            title="Full Black Premium-Module mit Spitzenwirkungsgrad"
                            content="Dank reduziertem Zellwiderstand liefern unsere vollständig schwarzen Doppelglas-Module mehr Leistung als herkömmliche Standardmodule. Mit einem beeindruckenden Wirkungsgrad von 23,8% und ihrem edlen Design vereinen sie Effizienz und Ästhetik – für maximale Energie und ein Dach, das sich sehen lassen kann."
                            gradient={true}
                            className="h-full p-8"
                        />
                    </div>

                    {/* Alle Stärken, die den Unterschied machen */}
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8 mt-16">
                        Alle Stärken, die den Unterschied machen
                    </h4>

                    {/* Interaktive Kacheln - nur die mit "mehr erfahren" */}
                    <div className="mb-12 max-w-6xl mx-auto">
                        {/* Using individual modal functions instead of TileGrid for these specific tiles */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {/* Box 1: Maximaler Ertrag bei Teilverschattung */}
                            <div
                                className="group relative rounded-2xl bg-white shadow-xl border border-gray-100 p-6 sm:p-8 cursor-pointer transition-all duration-500 ease-out hover:shadow-2xl hover:scale-[1.02] hover:bg-gray-50"
                                onClick={openModalBox1}
                            >
                                <div className="relative z-10 flex flex-col h-full">
                                    <div className="text-4xl text-primary mb-4 text-center group-hover:scale-110 transition-transform duration-500">
                                        <i className="fas fa-cloud-sun"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-gray-900 mb-4 text-center group-hover:text-primary transition-colors duration-300 break-words">
                                        Maximaler Ertrag bei Teilverschattung
                                    </h3>
                                    <p className="text-base text-gray-600 text-center flex-grow leading-relaxed break-words mb-4">
                                        Durch intelligente, integrierte Verschattungsoptimierung
                                    </p>
                                    <div className="text-center mt-auto">
                                        <span className="inline-flex items-center text-primary font-semibold text-base hover:text-primary-dark transition-all duration-300 group-hover:translate-x-1">
                                            mehr erfahren
                                            <i className="ml-2 fas fa-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {/* Box 2: 24,3% Wirkungsgrad */}
                            <div
                                className="group relative rounded-2xl bg-white shadow-xl border border-gray-100 p-6 sm:p-8 cursor-pointer transition-all duration-500 ease-out hover:shadow-2xl hover:scale-[1.02] hover:bg-gray-50"
                                onClick={openModalBox2}
                            >
                                <div className="relative z-10 flex flex-col h-full">
                                    <div className="text-4xl text-primary mb-4 text-center group-hover:scale-110 transition-transform duration-500">
                                        <i className="fas fa-percent"></i>
                                    </div>
                                    <h3 className="text-xl font-bold text-gray-900 mb-4 text-center group-hover:text-primary transition-colors duration-300 break-words">
                                        24,3% Wirkungsgrad
                                    </h3>
                                    <p className="text-base text-gray-600 text-center flex-grow leading-relaxed break-words mb-4">
                                        Effizienz auf höchstem Niveau
                                    </p>
                                    <div className="text-center mt-auto">
                                        <span className="inline-flex items-center text-primary font-semibold text-base hover:text-primary-dark transition-all duration-300 group-hover:translate-x-1">
                                            mehr erfahren
                                            <i className="ml-2 fas fa-arrow-right text-sm group-hover:translate-x-1 transition-transform duration-300"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mehr Vertrauen Section */}
                <div id="mehr-vertrauen" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Vertrauen
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Zuverlässige Sicherheit durch geprüfte Qualität
                    </h4>
                    <div className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        <p className="mb-6">
                            Die Sicherheit Ihrer Photovoltaikanlage ist von zentraler Bedeutung. Hochwertige Solarmodule bieten nicht nur starke Leistung, sondern auch umfassenden Schutz durch zertifizierte Prüfverfahren und streng kontrollierte Standards.
                        </p>
                        <p>
                            Dank moderner Technologien und regelmäßiger Qualitätstests können Sie sich auf eine stabile, langlebige und sichere Energieerzeugung verlassen – für ein gutes Gefühl, Tag für Tag.
                        </p>
                    </div>

                    {/* Two tiles side by side with maximum width */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto mb-12">
                        <ContentTile
                            title="Zertifizierte Sicherheit"
                            content="Die Solarmodule von Ampere sind vom TÜV Rheinland auf höchste Sicherheit geprüft und zertifiziert. Zusätzlich sind sie über die Münchener RE rückversichert – für maximale Absicherung und langfristige Investitionssicherheit."
                            gradient={true}
                            className="h-full p-8"
                        />
                        {/* Entire tile is now clickable */}
                        <div
                            className="cursor-pointer"
                            onClick={() => {
                                setModalData({
                                    isOpen: true,
                                    title: "Brandschutzklasse A – Höchste Sicherheit für Gebäude und Bewohner",
                                    content: [
                                        "Die Klassifizierung nach Brandschutzklasse A steht für nicht brennbare Materialien und ist ein zentrales Sicherheitsmerkmal bei der Auswahl von Solarmodulen. Sie stellt sicher, dass die Module im Falle eines Brandes keine zusätzliche Brandlast darstellen und somit das Risiko einer Feuerweiterleitung deutlich reduziert wird.",
                                        "Gerade weil Photovoltaikanlagen in der Regel auf dem Dach – also direkt an der Gebäudehülle – installiert werden, ist die Wahl feuerfester Komponenten essenziell. Module mit Brandschutzklasse A bieten einen wichtigen Beitrag zum Schutz von Eigentum und Bewohnern und erfüllen damit die hohen Anforderungen an moderne, sichere Gebäudetechnik.",
                                        "Dank der Glas-Glas-Eigenschaft der Solarmodule sind diese besonders witterungsbeständig und halten selbst hohen Schneebelastungen Stand."
                                    ]
                                });
                            }}
                        >
                            <ContentTile
                                title="Brandschutzklasse A"
                                content="Höchste Sicherheit für Gebäude und Bewohner"
                                className="text-center bg-secondary text-tertiary h-full p-8"
                                buttonText="mehr erfahren"
                            />
                        </div>
                    </div>
                </div>

                {/* Mehr Lebenszeit Section */}
                <div id="mehr-lebenszeit" className="mb-20 text-center">
                    <h3 className="text-2xl md:text-3xl font-semibold text-primary mb-6">
                        Mehr Lebenszeit
                    </h3>
                    <h4 className="text-xl md:text-2xl font-semibold text-gray-800 mb-8">
                        Qualität, die Jahrzehnte Bestand hat
                    </h4>
                    <p className="text-lg text-gray-700 leading-relaxed mb-12 max-w-4xl mx-auto">
                        Die Haltbarkeit von Solarmodulen ist ein wesentlicher Schlüssel für die Rentabilität und Zukunftssicherheit Ihrer Photovoltaikanlage. Dank moderner Fertigungsverfahren und hochwertiger Materialien überzeugen diese Module durch außergewöhnliche Robustheit und sichern eine gleichbleibend hohe Leistungsfähigkeit – zuverlässig über viele Jahre hinweg
                    </p>

                    {/* Two tiles side by side with maximum width */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto mb-12">
                        <ContentTile
                            title="Ihre Solaranlage liefert selbst nach 30 Jahren noch mindestens 88,85% ihrer Leistung – garantiert"
                            content=""
                            className="text-center bg-gradient-to-br from-gray-400 to-gray-300 text-white h-full p-8"
                        />
                        <ContentTile
                            title="Extrem Witterungsbeständig"
                            content="Witterungsbeständigkeit und Belastbarkeit sind
durch die Glas-Glas-Struktur der Module dauerhaft
gesichert"
                            className="text-center bg-gradient-to-br from-gray-300 to-lightgray-400 text-white h-full p-8"
                        />
                    </div>
                </div>
            </div>

            <div className="bg-gray-800 py-12">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-2xl font-bold text-white mb-8">Produktinformationen & Downloads</h2>
                    <div className="flex flex-col md:flex-row justify-center gap-6">
                        {/* First PDF Download */}
                        <div className="flex flex-col items-center">
                            <img
                                src={pdfpic1}
                                alt="Aiko"
                                className="mb-4 w-full max-w-xs h-auto"
                                onLoad={() => console.log('pdfPic1 loaded successfully')}
                                onError={(e) => {
                                    console.log('Error loading pdfPic1:', e);
                                    e.target.src = '/images/solarmodul/pdfpic1.png'
                                }}
                            />
                            <a
                                href="/pdf/solar/solarmodul_aiko.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Produktinformation AIKO NEOSTAR
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Modal component */}
            <Modal
                isOpen={modalData.isOpen}
                onClose={closeModal}
                title={modalData.title}
                content={modalData.content}
            />

            <Footer />
        </>
    );
};

export default SolarModules;